module.exports = __webpack_public_path__ + "static/media/icono-flecha.4e0b6a45.svg";